import { defineComponent } from 'vue'

import * as Icons from '@icons/index'

/**
 *
 * Icon component
 * @component CAIcon
 *
 * @prop {string} [dataTest=''] - The data-test attribute for testing purposes
 * @prop {string} icon - The name of the icon to render
 * @prop {string} [id=''] - The ID of the icon element
 * @prop {string} tooltip - The tooltip text to display when hovering over the icon
 *
 * @emit click - Emits a click event when the icon is clicked
 */
export default defineComponent({
	name: 'CAIcon',

	props: {
		/** Data test attribute for testing purposes
		 * @default ''
		 * @type {string}
		*/
		dataTest: { default: '', type: String },
		/**
		 * The name of the icon to render
		 * @required
		 * @type {string}
		 */
		icon: { required: true, type: String },
		/**
		 * The ID of the icon element
		 * @default ''
		 * @type {string}
		 */
		id: { default: '', type: String },
		/**
		 * The tooltip text to display when hovering over the icon
		 * @default ''
		 * @type {string}
		 */
		tooltip: { default: '', type: String },
	},

	emits: { click: () => true },

	setup(props, { emit }) {
		return () => {
			const IconComponent = (Icons as Record<string, any>)[props.icon]

			return (
				<IconComponent
					aria-hidden="true"
					class={`svg-component ${props.icon}`}
					data-test={props.dataTest}
					data-test-component="design-system-icon-component"
					id={props.id}
					v-tooltip={props.tooltip}
					onClick={() => emit('click')}
				/>
			)
		}
	},
})
